export enum ManageUserAction {
    Login, EditProfile, ChangePassword
}
